module.exports = __webpack_public_path__ + "static/media/0035.0f4e85b2.svg";